<ll-titulo>Editar plan de clase</ll-titulo>
<plan-clase-edit *ngIf="planPersonalId" [urlRediret]="urlRedirect" [planPersonalId]="planPersonalId"></plan-clase-edit>
